<script setup lang="ts">
type Props = { path?: string | null }

const props = withDefaults(defineProps<Props>(), { path: null })

const app = useNuxtApp()
const storeIndex = useStoreIndex()
const route = useRoute()

const pageData = reactive({
  areaItems: [],
  tabs: [],
  mdiClose: 'mdi-chevron-down',
  mdiOpen: 'mdi-chevron-up',
})

const refData = reactive({
  modelTab: 1,
  nUpdate: 0,

})

const makePrefList = () => {
  const masterArea = storeIndex.state.master.prefecture_area
  if (masterArea && masterArea.details) {
    const area = masterArea.details
    const list = []
    for (let i = 0; i < area.length; i++) {
      const item = {
        text: area[i].text,
        value: 'area-' + area[i].id,
        prefs: [],
        isOpen: false,
        icon: pageData.mdiClose,
      }
      const prefs = area[i].value.split(',')
      for (let j = 0; j < prefs.length; j++) {
        item.prefs.push({
          text: storeIndex.getPrefName(prefs[j]),
          value: 'pref-' + prefs[j],
        })
      }
      list.push(item)
    }
    pageData.areaItems = list
  }
}

const toggleItem = (item, event) => {
  if (item.isOpen) {
    item.isOpen = !item.isOpen
    item.icon = pageData.mdiClose
  } else {
    item.isOpen = true
    item.icon = pageData.mdiOpen
  }
}

const initPage = () => {
  makePrefList()
}
initPage()

watch(() => route.query, () => {
  if (!import.meta.client) return
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
},
)
</script>

<template>
  <div>
    <div class="c-SearchList_pc">
      <span class="c-SearchList_pc_label">
        都道府県から探す
      </span>
      <div
        v-if="pageData.areaItems.length > 0"
        class="c-SearchList_pc_box"
      >
        <div
          v-for="(recordArea, indexArea) in pageData.areaItems"
          v-bind:key="'area' + indexArea"
          class="c-SearchList_pc_box_line"
        >
          <div
            class="c-SearchList_pc_box_line_area"
          >
            <nuxt-link
              v-bind:to="path + '?area=' + recordArea.value"
            >
              {{ recordArea.text }}
            </nuxt-link>
          </div>
          <template
            v-if="recordArea.prefs.length > 0"
          >
            <div
              class="c-SearchList_pc_box_line_prefs"
            >
              <nuxt-link
                v-for="(recordPrefs, indexPrefs) in recordArea.prefs"
                v-bind:key="'prefs' + indexPrefs"
                v-bind:to="path + '?area=' + recordPrefs.value"
              >
                {{ recordPrefs.text }}
              </nuxt-link>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="c-SearchList_sp">
      <span class="c-SearchList_sp_label">
        都道府県から探す
      </span>

      <div
        class="c-SearchList_sp_body"
      >
        <div
          v-for="(recordArea, indexArea) in pageData.areaItems"
          v-bind:key="'area' + indexArea"
          v-bind:class="{ 'is-open': recordArea.isOpen }"
          class="c-SearchList_sp_body_box"
        >
          <div
            class="c-SearchList_sp_body_box_control"
            v-on:click="toggleItem(recordArea, $event)"
          >
            <span>
              {{ recordArea.text }}
            </span>
            <v-icon>{{ recordArea.icon }}</v-icon>
          </div>
          <div
            class="c-SearchList_sp_body_box_list"
          >
            <nuxt-link
              v-for="(recordPrefs, indexPrefs) in recordArea.prefs"
              v-bind:key="'prefs' + indexPrefs"
              v-bind:to="path + '?area=' + recordPrefs.value"
              class="c-SearchList_sp_body_box_list_link"
            >
              <div
                class="c-SearchList_sp_body_box_list_child"
              >
                <span>
                  {{ recordPrefs.text }}
                </span>
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.c-SearchList {
  &_pc {
    display: block;
    width: 100%;
    margin-top: 39px;
    padding: 28px 24px 31px 22px;
    background-color: #f1f4f6;

    @include responsive.mq_down(sp) {
      display: none;
    }

    &_label {
      color: #252525;
      font-size: 18px;
      font-weight: bold;
    }

    &_box {
      margin-top: 19px;

      &_line {
        display: flex;
        padding: 8px 0;
        border-bottom: 1px dashed #8c8e8f;

        &:first-of-type {
          border-top: 1px dashed #8c8e8f;
        }

        &_area {
          width: 80px;
          margin-bottom: 4px;

          a {
            margin: 0;
            padding: 0;
            color: #004ea2;
            font-size: 14px;
            font-weight: bold;
          }
        }

        &_prefs {
          margin-top: 4px;

          a {
            margin-left: 21px;
            color: #004ea2;
            font-size: 14px;

            &:first-of-type {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  &_sp {
    display: none;
    margin-top: 39px;
    padding: 27px 0 31px;
    background-color: #f1f4f6;

    @include responsive.mq_down(sp) {
      display: block;
    }

    &_label {
      margin-left: 17px;
      color: #252525;
      font-size: 18px;
      font-weight: bold;
    }

    &_body {
      margin-top: 19px;
      border-top: 1px dashed #8c8e8f;

      &_box {
        &_control {
          display: flex;
          justify-content: space-between;
          padding: 11px 7px 17px 17px;
          border-bottom: 1px dashed #8c8e8f;
          background-color: #f1f4f6;

          span {
            color: #252525;
            font-size: 14px;
            font-weight: bold;
          }

          .v-icon {
            color: #757575;
          }
        }

        &_list {
          display: none;
          background-color: #fff;

          &_link {
            text-decoration: none;
          }

          &_child {
            display: flex;
            justify-content: space-between;
            padding: 11px 7px 17px 32px;
            border-bottom: 1px dashed #8c8e8f;

            span {
              color: #004ea2;
              font-size: 14px;
            }

            .v-icon {
              color: #757575;
            }
          }
        }

        &.is-open {
          .c-SearchList_sp_body_box_list {
            display: block;
          }
        }
      }
    }
  }
}
</style>
